import type {
  CreateRbacRoleRequest,
  RbacRole,
  ReplaceRbacRoleAdminsRequest,
  ReplaceRbacRolePermissionsRequest,
  UpdateRbacRoleRequest,
} from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const createRbacRole = async (data: CreateRbacRoleRequest) => {
  const response = await gozokiApiWithAuth.post<RbacRole>('/rbac/roles', data)
  return response.data
}

export const updateRbacRole = async ({
  roleId,
  data,
}: {
  roleId: number
  data: UpdateRbacRoleRequest
}) => {
  const response = await gozokiApiWithAuth.patch<RbacRole>(`/rbac/roles/${roleId}`, data)
  return response.data
}

export const replaceRbacRolePermissions = async ({
  roleId,
  data,
}: {
  roleId: number
  data: ReplaceRbacRolePermissionsRequest
}) => {
  const response = await gozokiApiWithAuth.put<RbacRole>(`/rbac/roles/${roleId}/permissions`, data)
  return response.data
}

export const replaceRbacRoleAdmins = async ({
  roleId,
  data,
}: {
  roleId: number
  data: ReplaceRbacRoleAdminsRequest
}) => {
  const response = await gozokiApiWithAuth.put<RbacRole>(`/rbac/roles/${roleId}/admins`, data)
  return response.data
}
